import { Component, input } from '@angular/core';
import { Image } from '../../../models/image';

@Component({
  selector: 'inexp-image',
  imports: [],
  templateUrl: './image.component.html',
  styleUrl: './image.component.scss',
})
export class ImageComponent {
  image = input<Image>();
}
